import { render } from "./ShiftProductionPanel.vue?vue&type=template&id=3c945a9b&scoped=true"
import script from "./ShiftProductionPanel.vue?vue&type=script&lang=js"
export * from "./ShiftProductionPanel.vue?vue&type=script&lang=js"

import "./ShiftProductionPanel.vue?vue&type=style&index=0&id=3c945a9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c945a9b"]])

export default __exports__